<template>
  <div>
    <el-form ref="formRef" :rules="formRules" :model="form" label-width="90px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="附件名称" prop="attachName">
            <el-input maxlength="50"  v-model="form.attachName" ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="所在位置" prop="areaType">
            <el-select
                v-model="form.areaType"
                style="width:100%"
              >
                <el-option
                  v-for="item in attachAreaList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="description">
            <el-input type="textarea" v-model="form.description" maxlength="200"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件" prop="attachList">
            <VUpload :fileList="form.attachList" :limit="1" @uploadCallBack="uploadCallBack"> </VUpload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>

<script>
import VUpload from '@/views/components/v-upload';
import {  getBisDictData} from '@/api/common.js';
import { deviceTestSave,getAttachDetail } from './index.js';
export default {
  components: { VUpload },
  props: {
    deviceTestInfo:{},
    model:{},
    attach:{}
  },
  data() {
    return {
      attachList: [],
      attachAreaList:[],
      formRules: {
        attachName: [{ required: true, message: '附件名称不能为空', trigger: 'change' }],
       
        // description: [{ required: true, message: '备注不能为空', trigger: 'blur' }],

        attachList: [{ required: true, message: '上传附件不能为空', trigger: 'change' }],
      },
      form: {
        attachName: '',
        address: '',
         description: '',
        areaType:'',
        attachId: '',
        attachList: [],
      },
    };
  },
  created() {
    this.initData();
  },
  watch: {},
  methods: {
    initData(){
      console.log(this.deviceTestInfo)
      getBisDictData({
        projectId:this.deviceTestInfo.projectId,
        code: 'project_device_attach_area',
      }).then(res=>{
        this.attachAreaList = res.data
      })
        if(this.model!='add'){
            this.form.attachName=this.attach.attachName;
            this.form.areaType=this.attach.areaType;
            this.form.description=this.attach.description;
            getAttachDetail({id:this.attach.attachId}).then(res=>{
                this.form.attachList.push(res.data) 
            })
        }
        
    },
    cancleRecord() {
      this.$emit('attachEdit');
    },
    uploadCallBack(list){
      console.log(list)
      if(list.length==1){
        if(this.form.attachName==""){
          this.form.attachName = list[0].originalName
        }
      }
    },
    saveRecord(){
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            this.form.attachId= this.form.attachList[0].id
        this.form.attachUrl = this.form.attachList[0].link
            if(this.model=='add'){
            this.$emit('attachSubmit',this.form)
        }else{
            this.attach.attachId =this.form.attachId
            this.attach.attachUrl=this.form.attachUrl
            this.attach.attachName =this.form.attachName
            this.attach.address=this.form.address
            this.attach.description =this.form.description
            this.$emit('attachEdit')
        }
          } 
        });
    },
  },
};
</script>

<style scoped>
.btn {
  width: 100%;
  border: none;
  height: 30px;
  background: #409eff;
  font-size: 25px;
  color: #fff;
  line-height: 30px;
  margin-top: 10px;
}
.btn::after {
  display: none;
}
.btnArea {
  margin-top: 10px;
  text-align: center;
}
</style>
